import {ChildEntity} from "typeorm";
import {ShallowRef} from "vue";
import {Component} from "@vue/runtime-core";
import TransferOfferCareerEndNotificationComponent
  from "@/modules/transfer-market/components/TransferOfferCareerEndNotification.vue";
import {TransferOfferNotification} from "@/modules/transfer-market/entity/TransferOfferNotification";

@ChildEntity()
export class TransferOfferCareerEndNotification extends TransferOfferNotification {
  get component(): ShallowRef<Component> {
    return shallowRef(TransferOfferCareerEndNotificationComponent);
  }
}